import PropTypes from 'prop-types';
import React from 'react';

import { WindowScroller, AutoSizer } from 'react-virtualized';
import { connect } from 'react-redux';

class WindowAutoScroller extends React.Component {
  constructor(props) {
    super(props);
    this.windowScroller = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.updateCount !== this.props.updateCount) {
      this.windowScroller.current.updatePosition();
    }
  }

  render() {
    const { children } = this.props;

    return (
      <WindowScroller ref={this.windowScroller}>
        {({ height, isScrolling, onChildScroll, scrollTop }) => (
          <AutoSizer disableHeight>
            {({ width }) =>
              children({
                height,
                width,
                isScrolling,
                onScroll: onChildScroll,
                scrollTop
              })
            }
          </AutoSizer>
        )}
      </WindowScroller>
    );
  }
}

WindowAutoScroller.propTypes = {
  children: PropTypes.func,
  updateCount: PropTypes.number
};

export default connect(
  state => ({
    updateCount: state.ui.updateWindowAutoScroller
  }),
  null
)(WindowAutoScroller);
